import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';


class VisibleRenderer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { value, data } = this.props;
    if (!data) {
      return null;
    }
    const isVisible = value === true;
    const name = isVisible ? 'eye' : 'eye-slash';
    const cls = isVisible ? '' : 'text-muted';
    const popover = (
      <Tooltip id={`visible-tooltip-${data._id}`}>
        <div>
          {isVisible ? 'Visible announcement' : 'Hidden announcement'}
        </div>
      </Tooltip>
    );

    return (
      <div>
        <OverlayTrigger placement="right" overlay={popover}>
          <Fa className={cls} name={name} />
        </OverlayTrigger>
      </div>
    );
  }
}

VisibleRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
};
VisibleRenderer.defaultProps = {
  value: null,
  data: null,
};


export default VisibleRenderer;
